// Make new export in @reach-ui/auto-id
let id = 0;
export const genId = () => ++id;
